import { ListPageLayout } from "@/components/list-page-layout";
import { usePageTitle } from "@/hooks/use-page-title";
import { AIFieldsDataTable } from "./ai-fields-data-table";

export default function AIFieldsPage() {
  usePageTitle("AI Fields");

  return (
    <ListPageLayout
      pageType="ai-fields::list"
      title="AI Fields"
      className="max-w-full"
    >
      <AIFieldsDataTable />
    </ListPageLayout>
  );
}
